import React from 'react';
import { withApollo } from '@apollo/client/react/hoc';
import { Field } from 'formik';

import SecuritySearchQuery from 'buyside/graphql/queries/SecuritySearch';

import AutocompleteField from 'buyside/components/presentation/Form/Field/AutocompleteField/autocompleteField';

export class FundHoldingsAutocomplete extends React.Component {
  constructor() {
    super();
    this.state = { loading: false, sections: [] };
    this.selectIntercept = this.selectIntercept.bind(this);
    this.changeIntercept = this.changeIntercept.bind(this);
  }

  selectIntercept(value, selectedItem) {
    const { name, setFieldValue } = this.props;
    setFieldValue(name + '.primarySymbol', selectedItem.ticker);
    setFieldValue(name + '.fsId', selectedItem.id);
  }

  changeIntercept(query) {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: SecuritySearchQuery,
        variables: {
          query,
          assetClass: this.props.assetClass,
          includeLocalAsset: true,
          skip: false
        }
      })
      .then(res => {
        const { exact_matches, matching_tickers, matching_names } = JSON.parse(
          res.data.securitySearch
        );
        this.setState({
          loading: false,
          sections: [
            { title: `Exact ${this.props.assetClassLabel} Match`, suggestions: exact_matches },
            { title: `Partial ${this.props.assetClassLabel} Match`, suggestions: matching_tickers },
            {
              title: 'Company Name Match',
              suggestions: matching_names.filter(suggestion => suggestion.ticker)
            }
          ].filter(section => section.suggestions.length)
        });
      });
  }

  render() {
    const autosuggestOptions = {
      multiSection: true
    };
    return (
      <Field
        component={AutocompleteField}
        name={this.props.name + '.primarySymbol'}
        label={this.props.assetClassLabel}
        changeIntercept={this.changeIntercept}
        selectIntercept={this.selectIntercept}
        suggestions={this.state.sections}
        handleSuggestionsClearRequested={() => this.setState({ sections: [] })}
        formatSuggestion={suggestion => `${suggestion.ticker || ''} — ${suggestion.entity_name}`}
        getSuggestionValue={suggestion => suggestion.ticker}
        isWide
        autosuggestOptions={autosuggestOptions}
        loading={this.state.loading}
        debounce
      />
    );
  }
}

export default withApollo(FundHoldingsAutocomplete);
